import React from 'react';
import pendingImage from '../../../../../Assets/images/pending.png'



const AccountPendingModal = ({ onLogout  }) => {
  return (
    <div className="cprofile-overlay" id="cprofile-modal">
      <div className="avpending-content">
        <div className="cpf-top">
          <h2 className="text-center">Account Created - Pending Verification</h2>
        </div>
        <div className="cprofile-inner">
          <div className="vp-cvr">
            <div className="vp-image">
              <img src={pendingImage} alt="Pending Verification" />
            </div>
            <div className="vp-content">
              <h3>Thank you for signing up with HaulSync!</h3>
              <p>
                Your account has been created and is currently under review. An admin will verify your details shortly. You'll receive an email once your account is approved and ready to use.
              </p>
            </div>
            <div className="m-button">
              <button className="vp-button" onClick={onLogout }>Log Out</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPendingModal;
